import * as yup from "yup";
import BaseForm from "../../../../../../../../../shared/components/form/BaseForm";
import FormSelect from "../../../../../../../../../shared/components/select/FormSelect";

const AddCCSectionPermissionForm = ({ onSubmitHandler, sections }) => {
  const validationSchema = yup.object({
    section: yup.string().required("Debe elegir una sección"),
  });

  const defaultValues = {
    section: "",
  };

  return (
    <BaseForm
      onSubmitHandler={onSubmitHandler}
      validationSchema={validationSchema}
      defaultValues={defaultValues}
    >
      <FormSelect name="section" label="Secciones" options={sections} />
    </BaseForm>
  );
};

export default AddCCSectionPermissionForm;
